/**
 * Represent an item on the toolbar,
 * either a toplevel item or item in the dropdown menu
 * which is shown when hovering over the toplevel item.
 */
import Employee from '@/dataAccess/models/Employee'

export default class ToolbarItem {
  constructor(
    readonly name: string,
    readonly icon: string,
    readonly canAccess: (Employee) => boolean,
    readonly clickAction: () => void,
    public dropdownItems: Array<ToolbarItem>,
    readonly idPrefix: string
  ) {}

  accessibleToEmployee(employee: Employee): ToolbarItem | null {
    if (!this.canAccess(employee)) return null
    this.dropdownItems = this.dropdownItemsForEmployee(employee)
    return this
  }

  toFlat(): Array<ToolbarItem> {
    return !this.dropdownItems.length ? [this] : this.dropdownItems
  }

  private dropdownItemsForEmployee(employee: Employee): Array<ToolbarItem> {
    return this.dropdownItems.filter(item => item.canAccess(employee))
  }
}
